module.exports = __webpack_public_path__ + "files/dd98ad84513b260d4ed832688f970512.png";